import styled from 'styled-components';
import { color, textContrast } from '@magalu/stereo-ui-styles';
import { background, border, layout, position, shadow, space, textAlign, typography, compose } from 'styled-system';
export const Container = styled.div({
  boxSizing: 'border-box',
  cursor: ({
    touch
  }) => touch ? 'pointer' : 'inherit'
}, compose(background, border, layout, position, shadow, space, textAlign, typography, color), textContrast);